// extracted by mini-css-extract-plugin
export default {"photobody":"photo_photobody__7f4x6","boxx":"photo_boxx__JpOAM","photodiv":"photo_photodiv__uAA01"};